// extracted by mini-css-extract-plugin
var _1 = "Tray__img--XSitI";
export { _1 as "img" }
